import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import { useApiError } from '../useApiError';
export const useOrderCreate = (orderId: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // //console.log("useOrderCreatemethodcontext---------", context.useApiError);
  const { set: setError } = useApiError();
  // Shared ref holding the response from the API
  const result = sharedRef(null, `useOrderCreate-${orderId}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useOrderCreate-loading-${orderId}`);

  // Shared ref holding errors from the methods
  const error = sharedRef(null, `useOrderCreate-error-${orderId}`);

  // 发起支付
  const create = async (customQuery) => {
    try {
      loading.value = true;
      // console.log("pay参数---------", customQuery);
      const res = await context.$xbuy.api.orderCreate(customQuery);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        result.value = res.data;
        error.value = null;
      } else if (res && res.code === 3605) {
        var title = '';
        if (res?.data?.items) {
          res.data.items.forEach((item) => {
            if (item.out_id === res.data.not_matched_out_id)
              title += item.title + ' ' + item.sku_prop + ' ';
          });
        }
        setError({ code: res.code, message: (title || '') + res.message, time: 3000 });
        error.value = res.message;
        result.value = null;
      } else {
        setError({ code: res.code, message: res.message, time: (res.code === 3208 || res.code === 3128) ? 8000 : 3000 });
        error.value = res.message;
        result.value = null;
      }
    } catch (err) {
      error.value = err.message;
      result.value = null;

    } finally {
      loading.value = false;
    }
  };

  return {
    create,
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
